import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

const CollectionsHomeRoute = (
  <Route
    key="CollectionsHome"
    path="/collections"
    component={
      Loadable({
        loader: () => import(
          /* webpackChunkName: "Collections" */
          './Container'
        ),
        loading: () => null
      })
    }
  />
);

export default CollectionsHomeRoute;
